import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Accordion } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import {
  NewChequePaymentFormSchemaOptions,
  OneTimeACHPaymentFormSchemaOptions,
} from "../../Utils/formOptions";
import { useAbortController } from "../../hooks/useAbortController";
import useBorowerLoanDetail from "../../hooks/useBorowerLoanDetail";
import urls from "../../Utils/urls";
import {
  handleRoutingDetails,
  setSameDayPayment,
} from "../../store/reducers/achPaymentSlice";
import { RoutingNumberValidator } from "../Borrowers/Pages/ACHPayments/SameDayPayment";
import AddAccountModal from "../Borrowers/Pages/ACHPayments/AddAccountModal";
import DeleteAccountModaal from "../Borrowers/Pages/ACHPayments/DeleteAccountModal";
import { loadingTypes } from "../../Utils/constant";
import { BlurWrapperWithSpan, SpinnerBlock } from "../../Utils/CustomComponent";

import useAchData from "../Borrowers/BankAccountACHPayments/useAchData";
import {
  TaxFormModal,
  TaxInfoModal,
} from "../Borrowers/BorrowerDashboard/AchPopup";
import { SelectAccount } from "../../components/Navbar";
import { fetchBorrowerAllLoansBankDetails } from "../../store/reducers/dashboardSlice/api";
import {
  ArrowLeft,
  ExclamationTriangle,
  Person,
  FileEarmark,
  Calendar,
  CurrencyDollar,
  CreditCard,
} from "react-bootstrap-icons";
import useBorrowerDashboardTwo from "../Borrowers/BorrowerDashboardTwo/apis/useBorrowerDashboardTwo";
import axios from "../../axios";
import moment from "moment";

const OneTimePaymentForm = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [achInfo, setAchInfo] = useState({});
  const [routingDetails, setRoutingDetails] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  const [showAccountForm, setShowAccountForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTaxForm, setShowTaxForm] = useState(false);
  const [showTaxInfo, setShowTaxInfo] = useState(false);

  const location = useLocation();
  const nsfData = location.state?.nsfData;

  // Extract NSF data for display
  const borrowerName = nsfData?.borrower || "Borrower";
  const loanNumber = nsfData?.loanNumber || "N/A";
  const failedAmount = nsfData?.isChecked
    ? nsfData?.numberAmountIncludingNSFFee
    : Math.abs(nsfData?.Amount);

  const maskedAccount = nsfData?.BankNumber
    ? `****${String(nsfData.BankNumber).slice(-4)}`
    : "N/A";
  const failureDate = nsfData?.dateFormatted || "N/A";
  const nsfFee =
    typeof nsfData?.nsfFee === "number" && nsfData?.nsfFee > 0
      ? nsfData.nsfFee
      : 45;

  const accountId = useSelector((state) => state.account.lenderId);
  const { activeAccountList } = useBorrowerDashboardTwo();
  const { loanDetails, status } = useBorowerLoanDetail(accountId);
  // const { bankDetails: paymentAccounts, status: optionStatus } =
  //   useBankDetails(accountId);
  const paymentAccounts = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.data,
  );
  const optionStatus = useSelector(
    (state) => state.dashboard.borrowerAllLoansBankAccounts.status,
  );
  const { fetchACHData, achData, loading: taxInfoLoading } = useAchData();

  const [selectedPaymentAccount, setSelectedPaymentAccount] = useState(
    null,
    // paymentAccounts?.options ? paymentAccounts.options[0] : null
  );
  const [currentDate, setCurrentDate] = useState(null);
  const [refetchDate, setRefetchDate] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm(OneTimeACHPaymentFormSchemaOptions);
  const { signal } = useAbortController();
  // const location = useLocation();
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);

  const routingNumber = watch("routingNumber");
  const accountNumber = watch("accountNumber");
  const paymentType = watch("paymentType");
  // const verifyAccountNumber = watch("verifyAccountNumber");
  const accountIds = activeAccountList?.map((data) => data.value);
  const userId = localStorage.getItem("apex_userid");
  const options = paymentAccounts?.options || [];
  const clonedOptions = [...options];
  clonedOptions?.unshift({
    label: "+ Add New",
    value: "Add New",
  });
  clonedOptions?.unshift({
    label: "Select Value",
    value: "Select Value",
  });

  useEffect(() => {
    if (accountId) {
      fetchACHData(accountId);
      setValue("loan_account", loanNumber);
    }
  }, [accountId]);

  useEffect(() => {
    setValue("paymentType", "NSF");
  }, []);

  useEffect(() => {
    if (accountIds?.length) {
      dispatch(
        fetchBorrowerAllLoansBankDetails({
          requestBody: {
            RecID: accountIds.join(","),
          },
          userId,
          signal,
        }),
      );
    }
  }, [accountIds?.length]);

  useEffect(() => {
    if (achData?.length) {
      const show = achData[0].DISABLE_YN.toLowerCase() === "y" ? true : false;

      setShowTaxForm(show);
    }
  }, [achData?.length]);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      try {
        setDisableBtn(true);
        const getData = await axios.get(
          urls.borrower.getRoutingNumberValidation(routingNumber),
          { signal },
        );

        if (getData?.data.code == 404) {
          setError("routingNumber", {
            type: "custom",
            message: "Invalid routing number",
          });
          setShowRoutingNumberVaildatorPopup(true);
          setIsRoutingNumberVerified(false);
          setRoutingDetails({});
          dispatch(handleRoutingDetails({}));
          // setDisableBtn(true);
        } else if (getData?.data.code == 200) {
          setIsRoutingNumberVerified(true);
          setRoutingDetails(getData.data);
          dispatch(handleRoutingDetails(getData.data));
          setDisableBtn(false);
          clearErrors("routingNumber");
        }
        return getData.data;
      } catch (error) {
        setError("routingNumber", {
          type: "custom",
          message: "Routing validation failed",
        });
        setRoutingDetails({});
        dispatch(handleRoutingDetails({}));
        setShowRoutingNumberVaildatorPopup(true);
        setIsRoutingNumberVerified(false);
        // setDisabled(true);
      }
    };
    if (routingNumber?.length === 9) {
      handleRoutingNumberValidation();
    } else if (routingNumber?.length && routingNumber?.length !== 9) {
      setError("routingNumber", {
        type: "custom",
        message: "Routing number must be 9 digits",
      });
      setRoutingDetails({});
      dispatch(handleRoutingDetails({}));
      setDisableBtn(true);
    }
  }, [routingNumber]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        urls.borrower.getPaymentsLoanAchSameDayInfo(accountId),
        { signal },
      );

      let data = res.data[0][0];
      setAchInfo(data);
      // setValue("bankAccountName", data?.ACH_IndividualName);
      setValue("payTo", "Superior Loan Servicing");
      setValue("amount", `${failedAmount}`);
      // setValue("routingNumber", data?.ACH_RoutingNumber);
      // setValue("accountNumber", data?.ACH_AccountNumber);
      // setValue("verifyAccountNumber", data?.ACH_AccountNumber);
    };
    fetchData();
  }, [accountId, setValue, failedAmount]);

  useEffect(() => {
    if (optionStatus === loadingTypes.fulfilled) {
      if (selectedPaymentAccount) {
        setValue("bankAccountName", selectedPaymentAccount?.ACH_INDIVIDUALNAME);
        setValue("routingNumber", selectedPaymentAccount?.routing_number);
        setValue("accountNumber", selectedPaymentAccount?.account_number);
        // setValue("verifyAccountNumber", selectedPaymentAccount?.account_number);
      } else {
        // setValue(
        //   "bankAccountName",
        //   paymentAccounts?.data?.[0]?.ACH_INDIVIDUALNAME
        // );
        // setValue("routingNumber", paymentAccounts?.data?.[0]?.routing_number);
        // setValue("accountNumber", paymentAccounts?.data?.[0]?.account_number);
        // setValue(
        //   "verifyAccountNumber",
        //   paymentAccounts?.data?.[0]?.account_number
        // );
      }
    } else if (optionStatus === loadingTypes.loading) {
      setSelectedPaymentAccount(null);
    }
  }, [selectedPaymentAccount, optionStatus]);

  useEffect(() => {
    setValue("memo", paymentType);
  }, [paymentType, setValue]);

  useEffect(() => {
    const getCurrentDate = async () => {
      try {
        const res = await axios.get(urls.borrower.currentDateNTime);
        const data = res?.data?.datetime;
        setCurrentDate(data);
      } catch (error) {
        console.error(error);
      }
    };

    getCurrentDate();
  }, [refetchDate]);

  const onSubmit = (data) => {
    // if (accountNumber && verifyAccountNumber) {
    // if (accountNumber !== verifyAccountNumber) {
    //   setError("verifyAccountNumber", {
    //     type: "custom",
    //     message: "Account numbers do not match",
    //   });
    // } else {
    data.isRoutingNumberVerified = isRoutingNumberVerified;
    dispatch(
      setSameDayPayment({
        ...data,
        // amount: `${Math.abs(data?.amount)}`,
        loan_account_number: achInfo?.loan_account_number,
        bankName: routingDetails.customer_name,
        bankAddress: routingDetails.address,
        bankCity: routingDetails.city,
        bankState: routingDetails.state,
        bankZip: routingDetails.zip,
        bankTelephone: routingDetails.telephone,
        selectedDate: moment(data.selectedDate).format("MM/DD/YYYY"),
      }),
    );
    setShowPopup(true);
    navigate("/preview-check", { state: { parent: "One Time" } });
    // }
    // }
  };

  function handleAccountChange(e) {
    setLoading(true);
    setSelectedPaymentAccount(e);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }

  const styles = {
    container: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
    },
    th: {
      textAlign: "left",
      backgroundColor: "#f0f0f0",
      padding: "10px",
      border: "1px solid black",
    },
    td: {
      padding: "10px",
      border: "1px solid black",
    },
  };
  const infoBoxStyle = {
    margin: "0.5em",
    padding: "0.5em",
    background: "#E5E5E5",
    fontSize: "1.4rem",
    lineHeight: "1.4",
    borderRadius: "8px",
  };

  if (!nsfData) {
    return <Navigate to="/nsf" replace />;
  }

  return (
    <div style={{ overflowY: "scroll" }}>
      {!taxInfoLoading ? (
        <section
          className=" rounded"
          style={{ background: "#eeeeee", minHeight: "100vh" }}
        >
          <article className="container-fluid">
            <div className="p-5 pb-0  mt-1">
              <span
                className="linkClick"
                role="button"
                onClick={() => navigate(-2)}
              >
                <ArrowLeft size={20} /> Back
              </span>{" "}
              / <span>One Time Payment Form</span>
            </div>
          </article>
          {status === loadingTypes.fulfilled ? (
            <article className="container-fluid py-5 rounded">
              <section className="bg-white p-5 my-2 mx-4">
                <div className="row"></div>
                <h4 className="mt-5">One Time Payment Form</h4>
                <h5 className="p-5 border text-muted">
                  Please review your submission carefully, especially the
                  routing and account numbers on the check image. Submission
                  isn’t complete until you sign and press "Submit" on the next
                  page. A confirmation email will follow.
                </h5>
                {/* NSF Details Section */}
                {nsfData && (
                  <section className="bg-white p-4 my-2 mx-4 mb-4">
                    {/* Payment Details Section */}
                    <div className="nsf-payment-details">
                      <h5 className="nsf-section-title">
                        NSF Case Information
                      </h5>

                      <div className="nsf-payment-grid">
                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-blue">
                            <Person size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">
                              Borrower Name
                            </div>
                            <div className="nsf-payment-value">
                              {borrowerName}
                            </div>
                          </div>
                        </div>

                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-blue">
                            <FileEarmark size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">Loan Number</div>
                            <div className="nsf-payment-value">
                              {loanNumber}
                            </div>
                          </div>
                        </div>

                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-red">
                            <Calendar size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">
                              Non-Sufficient Funds Date
                            </div>
                            <div className="nsf-payment-value">
                              {failureDate}
                            </div>
                          </div>
                        </div>

                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-green">
                            <CurrencyDollar size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">
                              NSF Payment Amount
                            </div>
                            <div className="nsf-payment-value">
                              {failedAmount !== null ? failedAmount : "N/A"}
                            </div>
                          </div>
                        </div>

                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-gray">
                            <CreditCard size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">
                              Account Used
                            </div>
                            <div className="nsf-payment-value">
                              {maskedAccount}
                            </div>
                          </div>
                        </div>

                        <div className="nsf-payment-item">
                          <div className="nsf-payment-icon nsf-payment-icon-warning">
                            <ExclamationTriangle size={20} />
                          </div>
                          <div className="nsf-payment-info">
                            <div className="nsf-payment-label">NSF Fee</div>
                            <div className="nsf-payment-value nsf-fee-value">
                              ${nsfFee}
                            </div>
                          </div>
                        </div>

                        {nsfData?.LateCharges ? (
                          <div className="nsf-payment-item">
                            <div className="nsf-payment-icon nsf-payment-icon-warning">
                              <ExclamationTriangle size={20} />
                            </div>
                            <div className="nsf-payment-info">
                              <div className="nsf-payment-label">
                                Late Charges
                              </div>
                              <div className="nsf-payment-value nsf-fee-value">
                                ${nsfData?.LateCharges}
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </section>
                )}
                <form>
                  <div className="loans-in-details mt-5">
                    <div className="col-sm-12 col-md-12 ">
                      <table style={styles.container}>
                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Management Company Name:
                          </th>
                          <td style={styles.td} colSpan="3">
                            Superior Loan Servicing
                          </td>
                        </tr>

                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Loan Number:
                          </th>
                          <BlurWrapperWithSpan>
                            <td style={styles.td} colSpan="3">
                              {achInfo?.loan_account_number}
                            </td>
                          </BlurWrapperWithSpan>
                        </tr>
                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Phone Cell:
                          </th>
                          <td style={styles.td} colSpan="3">
                            {achInfo?.phonecell ? achInfo.phonecell : "-"}
                          </td>
                        </tr>
                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Phone Work:
                          </th>
                          <td style={styles.td} colSpan="3">
                            {achInfo?.phonework ? achInfo?.phonework : "-"}
                          </td>
                        </tr>
                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Pay To:
                          </th>
                          <td style={styles.td} colSpan="3">
                            Superior Loan Servicing
                          </td>
                        </tr>
                        <tr>
                          <th
                            style={styles.th}
                            className="bg-primary text-white"
                          >
                            Property Address:
                          </th>
                          <td style={styles.td} colSpan="3">
                            {
                              loanDetails?.loanTerm?.loanheader2?.split?.(
                                ":",
                              )?.[1]
                            }
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div className=" p-5 mt-5 row">
                      <div className="col-6">
                        <label htmlFor="accounts" className="fw-bold">
                          Choose Bank Account:
                        </label>
                        {optionStatus === loadingTypes.fulfilled ? (
                          <div className="my-3">
                            <Select
                              id="accounts"
                              // options={paymentAccounts?.options}
                              options={clonedOptions}
                              // value={selectedPaymentAccount}
                              defaultValue={clonedOptions?.[0]}
                              onChange={handleAccountChange}
                              classNamePrefix="select"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  primary: "#ef8860",
                                },
                              })}
                            />
                          </div>
                        ) : optionStatus === loadingTypes.loading ? (
                          <div style={{ margin: "2rem" }}>
                            <SpinnerBlock height="50vh" />
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {optionStatus === loadingTypes.fulfilled && !loading ? (
                      sameDayPaymentArr(
                        achInfo?.loan_account_number,
                        loanDetails?.loanTerm?.loanheader2?.split?.(":")?.[1],
                        control,
                        selectedPaymentAccount,
                        paymentType,
                        nsfData?.isChecked,
                        currentDate,
                        setRefetchDate,
                      )?.map((data, index) => {
                        return (
                          <MultipleFormBoxComp
                            key={index}
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            options={data.arr}
                            errors={errors}
                          />
                        );
                      })
                    ) : optionStatus === loadingTypes.loading || loading ? (
                      <div>
                        <SpinnerBlock height="2vh" />
                      </div>
                    ) : null}

                    <div className="text-center">
                      <button
                        type="button"
                        className="mt-5 btn btn-secondary border me-5"
                        style={{ width: "fit-content" }}
                        onClick={() => navigate(-2)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="mt-5 btn btn-primary"
                        style={{ width: "fit-content" }}
                        disabled={disableBtn}
                        onClick={handleSubmit(onSubmit)}
                      >
                        Preview
                      </button>
                    </div>
                  </div>
                </form>
              </section>
            </article>
          ) : status === loadingTypes.loading ? (
            <div style={{ paddingTop: "8rem" }}>
              <SpinnerBlock height="50vh" />
            </div>
          ) : status === loadingTypes.error ? (
            <div>Some error occured</div>
          ) : null}
        </section>
      ) : (
        <div style={{ marginTop: "10rem" }}>
          <SpinnerBlock height="50vh" />
        </div>
      )}
      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisableBtn}
        routingNumber={routingNumber}
      />

      <AddAccountModal show={showAccountForm} setShow={setShowAccountForm} />
      <DeleteAccountModaal
        show={showDeleteForm}
        setShow={setShowDeleteForm}
        AccountSelect={
          <Select
            options={paymentAccounts}
            value={selectedPaymentAccount}
            onChange={handleAccountChange}
            classNamePrefix="select"
          />
        }
        selectedPaymentAccount={selectedPaymentAccount}
      />

      <TaxFormModal
        show={showTaxForm}
        setShow={setShowTaxForm}
        setShowTaxInfo={setShowTaxInfo}
      />

      <TaxInfoModal
        show={showTaxInfo}
        setShow={setShowTaxInfo}
        achCondition={false}
      />
      <style>
        {`
          .accordion-button:not(.collapsed) {
          color: #fff; 
          background-color: var(--primary-color);
          }

          /* NSF Detail Styles */
          .nsf-header-alert {
            padding: 20px 24px !important;
            display: flex !important;
            align-items: center !important;
            margin: 0 0 20px 0 !important;
            background: #f8d7da !important;
            border-radius: 8px !important;
            border: 1px solid #f5c6cb !important;
          }

          .nsf-alert-icon {
            margin-right: 16px !important;
            color: #dc3545 !important;
            display: flex !important;
            align-items: center !important;
          }

          .nsf-alert-content {
            flex: 1 !important;
          }

          .nsf-alert-title {
            font-size: 18px !important;
            font-weight: 600 !important;
            color: #dc3545 !important;
            margin-bottom: 4px !important;
            line-height: 1.3 !important;
          }

          .nsf-alert-message {
            font-size: 15px !important;
            color: #dc3545 !important;
            opacity: 0.9 !important;
            margin: 0 !important;
          }

          /* NSF Warning Section */
          .nsf-warning-section {
            background: #f8d7da !important;
            margin: 0 0 20px 0 !important;
            padding: 16px 20px !important;
            border-radius: 8px !important;
            border: 1px solid #f5c6cb !important;
            display: flex !important;
            align-items: flex-start !important;
          }

          .nsf-warning-icon {
            margin-right: 12px !important;
            color: #721c24 !important;
            margin-top: 2px !important;
          }

          .nsf-warning-content {
            flex: 1 !important;
          }

          .nsf-warning-title {
            font-size: 16px !important;
            font-weight: 600 !important;
            color: #721c24 !important;
            margin-bottom: 6px !important;
          }

          .nsf-warning-message {
            font-size: 14px !important;
            color: #721c24 !important;
            line-height: 1.5 !important;
            margin: 0 !important;
          }

          /* Payment Details Section */
          .nsf-payment-details {
            margin: 20px 0 !important;
          }

          .nsf-section-title {
            font-size: 18px !important;
            font-weight: 600 !important;
            color: #2c3e50 !important;
            margin-bottom: 16px !important;
          }

          .nsf-payment-grid {
            background: white !important;
            border-radius: 0px !important;
            padding: 0 !important;
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 16px 24px !important;
          }

          .nsf-payment-item {
            display: flex !important;
            align-items: center !important;
            padding: 0 !important;
          }

          .nsf-payment-icon {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            flex-shrink: 0;
          }

          .nsf-payment-icon-green {
            background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
            color: #155724;
          }

          .nsf-payment-icon-red {
            background: linear-gradient(135deg, #e7f3ff 0%, #cce7ff 100%);
            color: #0c5460;
          }

          .nsf-payment-icon-gray {
            background: linear-gradient(135deg, #f1f3f4 0%, #e9ecef 100%);
            color: #6c757d;
          }

          .nsf-payment-icon-warning {
            background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
            color: #856404;
          }

          .nsf-payment-icon-blue {
            background: linear-gradient(135deg, #e7f3ff 0%, #cce7ff 100%);
            color: #0c5460;
          }

          .nsf-payment-info {
            flex: 1;
          }

          .nsf-payment-label {
            font-size: 14px;
            color: #6c757d;
            margin-bottom: 4px;
            font-weight: 500;
          }

          .nsf-payment-value {
            font-size: 18px;
            font-weight: 600;
            color: #2c3e50;
          }

          .nsf-fee-value {
            color: #dc3545;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .nsf-payment-grid {
              grid-template-columns: 1fr;
              gap: 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OneTimePaymentForm;

const sameDayPaymentArr = (
  loanNumber,
  propertyAddress,
  control,
  selectedPaymentAccount,
  paymentType,
  isChecked,
  currentDate,
  setRefetchDate,
) => {
  // 1. Parse the server date string to prevent users from manipulating their local system clock
    const today = moment(currentDate);
  
    // 2. Clone the server date before manipulation to avoid mutating the original instance
    const endOfMonth = today.clone().endOf("month");
  
    // Find last business day of the month
    let lastBusinessDay = endOfMonth.clone();
    while (lastBusinessDay.day() === 0 || lastBusinessDay.day() === 6) {
      lastBusinessDay.subtract(1, "day");
    }
  
    // Determine maxDate based on server time
    const maxDate = today.isSame(lastBusinessDay, "day")
      ? today.clone().add(1, "month").endOf("month").toDate() // allow next month
      : endOfMonth.toDate();
  
    const minDate = today.clone().add(1, "days").toDate();

  return [
    {
      field: "",
      arr: [
        {
          section: "",
          className: "col-md-12 col-sm-12",
          arr: [
            {
              title: "Bank Account Number",
              field: "accountNumber",
              type: "number",
              className: "col-6",
              disablePaste: true,
              // eyeIcon: true,
              disable:
                selectedPaymentAccount === null ||
                selectedPaymentAccount?.value === "Add New"
                  ? false
                  : true,
            },
            {
              title: "Name on Bank Account",
              field: "bankAccountName",
              type: "text",
              className: "col-6",
              disable:
                selectedPaymentAccount === null ||
                selectedPaymentAccount?.value === "Add New"
                  ? false
                  : true,
            },
            {
              title: "Check Amount",
              field: "amount",
              type: "amount",
              control: control,
              placeholder: "Enter amount in dollars & cents (e.g., $100.52)",
              className: "col-6",
              disable: isChecked,
            },
            {
              title: "Routing Number *",
              field: "routingNumber",
              type: "number",
              className: "col-6",
              disablePaste: true,
            },
            // {
            //   title: "Payee’s Name:",
            //   field: "PayeesName",
            //   type: "text",
            //   className: "col-12",
            // },
            // {
            //   title: "C/O:",
            //   field: "CareOf",
            //   type: "text",
            //   className: "col-12",
            // },
            {
              title: "Your Street Address as on your Bank Account",
              // field: "PayeesAddressLine1",
              field: "address",
              type: "text",
              className: "col-12",
            },
            {
              title: "Your City, State, Zip as on your Bank Account",
              // field: "PayeesAddressLine2",
              field: "cityStateZip",
              type: "text",
              className: "col-12",
            },
            {
              title: "Comments/Instructions:",
              field: "memo",
              type: "text",
              className: "col-12",
              disable: true,
            },
            {
              title: "Payment Date",
              field: "selectedDate",
              type: "date",
             minDate: minDate,
              maxDate: maxDate,
              // defaultValue: new Date(moment().add(1, "days")),
              filter: true,
              className: "col-12 mt-5",
              onFocus: () => {
                setRefetchDate((prev) => !prev);
              },
            },
          ],
        },
      ],
    },
  ];
};
